import {
  Button,
  BUTTON_COLOR_RED,
  BUTTON_VARIANT_CONTAINED,
} from '@sgcmpteltd/uikit-react/components/button';
import {
  Result,
  RESULT_VARIANT_ERROR,
  RESULT_VARIANT_SUCCESS,
} from '@sgcmpteltd/uikit-react/components/result';

import { TextLink } from '@/components/text-link';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Step: Component = ({
  alertPageLink,
  isSuccess,
  title,
  onClose,
}) => (
  <div
    className={styles.containerRoot}>
    <Result
      message=""
      title={title}
      variant={
        isSuccess
          ? RESULT_VARIANT_SUCCESS
          : RESULT_VARIANT_ERROR
      } />
    <div
      className={styles.containerCloseButton}>
      <Button
        color={BUTTON_COLOR_RED}
        variant={BUTTON_VARIANT_CONTAINED}
        onClick={() => {
          onClose?.();
        }}>
        Close
      </Button>
    </div>
    <span>
      Or go to my
      {' '}
      <TextLink
        href={alertPageLink}
        text="alerts page" />
    </span>
  </div>
);
